var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('div', {
    class: _vm.$style.viewContainer
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [!_vm.gridView ? _c('div', [_c('div', {
    staticClass: "justify-content-between"
  }, [_c('BaseTitle', {
    staticClass: "mb-4",
    class: _vm.$style.title
  }, [_vm._v("Resources")]), _c('div', {
    class: _vm.$style.headerContent
  }, [_c('InfoBlock', {
    class: _vm.$style.infoBlock
  }, [_vm._v(" " + _vm._s(_vm.infoBlockMessage) + " ")]), _c('CategorySelector', {
    class: _vm.$style.categorySelector,
    attrs: {
      "categories": _vm.getDistinctCategories,
      "allow-empty": true,
      "show-all-button": true,
      "change-url": true,
      "selected-category": _vm.selectedCategory
    },
    on: {
      "update:selectedCategory": function updateSelectedCategory($event) {
        _vm.selectedCategory = $event;
      },
      "update:selected-category": function updateSelectedCategory($event) {
        _vm.selectedCategory = $event;
      }
    }
  })], 1)], 1), !_vm.selectedCategory ? _c('div', {
    class: (_class = {}, _class[_vm.$style.gridView] = true, _class[_vm.$style.resourceCarousel] = true, _class)
  }, [_c('h3', [_vm._v("Favorite Resources")]), _c('transition-group', _vm._l(_vm.getFavoriteResources, function (resource) {
    return _c('ResourceBlock', {
      key: resource.resourceId,
      class: _vm.$style.resourceBlock,
      attrs: {
        "resource": resource
      }
    });
  }), 1), !_vm.getFavoriteResources.length ? _c('p', {
    class: _vm.$style.emptySentence
  }, [_vm._v(" Click the heart to favorite a resource. ")]) : _vm._e()], 1) : _vm._e(), !_vm.selectedCategory ? _c('ResourceCarousel', {
    class: _vm.$style.resourceCarousel,
    attrs: {
      "resources": _vm.getPopularResources,
      "category": "Popular Items"
    },
    on: {
      "openGridView": function openGridView($event) {
        return _vm.changeSelectedSubcategory('popular');
      }
    }
  }) : _vm._e(), !_vm.selectedCategory ? _c('ResourceCarousel', {
    class: _vm.$style.resourceCarousel,
    attrs: {
      "resources": _vm.getRecentlyAddedResources,
      "category": "Recently Added"
    },
    on: {
      "openGridView": function openGridView($event) {
        return _vm.changeSelectedSubcategory('recent');
      }
    }
  }) : _vm._e(), _vm._l(_vm.getDistinctSubcategories, function (subcategory) {
    return _c('ResourceCarousel', {
      key: subcategory,
      class: _vm.$style.resourceCarousel,
      attrs: {
        "category": subcategory,
        "resources": _vm.getResourcesFromSubcategory(subcategory)
      },
      on: {
        "openGridView": function openGridView($event) {
          return _vm.changeSelectedSubcategory(subcategory);
        }
      }
    });
  })], 2) : _vm._e(), _vm.gridView ? _c('div', {
    class: _vm.$style.gridView
  }, [_c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.backButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "gray"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.activateCarouselView.apply(null, arguments);
      }
    }
  }), _c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer",
    on: {
      "click": _vm.activateAllResourcesView
    }
  }, [_vm._v("RESOURCES")]), _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "name": "chevron-right"
    }
  }), _vm.gridViewCategoryName ? _c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer",
    on: {
      "click": _vm.activateCarouselView
    }
  }, [_vm._v(" " + _vm._s(_vm.gridViewCategoryName.toUpperCase()) + " ")]) : _vm._e(), _vm.gridViewCategoryName ? _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "name": "chevron-right"
    }
  }) : _vm._e(), _c('p', {
    staticClass: "button-text color-primary-blue",
    class: _vm.$style.selectedBreadcrumb
  }, [_vm._v(" " + _vm._s(_vm.gridViewLabel.toUpperCase()) + " ")])], 1), _c('h2', [_vm._v(_vm._s(_vm.gridViewLabel))]), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l(_vm.gridViewResources, function (resource) {
    return _c('ResourceBlock', {
      key: resource.resourceId,
      class: _vm.$style.resourceBlock,
      attrs: {
        "resource": resource
      }
    });
  }), 1), _vm.gridViewEmptySentence && !_vm.gridViewResources.length ? _c('p', [_vm._v(_vm._s(_vm.gridViewEmptySentence))]) : _vm._e()], 1) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "view-resource-modal",
      "modal-class": ['right', 'modal-resource'],
      "hide-footer": "",
      "hide-header": "",
      "title": "BootstrapVue"
    }
  }, [_c('ModalResource', {
    attrs: {
      "toast-component": this.$bvToast
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }